import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getDataBS } from '../../../utils/awsService';
import './ConsultationDetails.css';

const PaymentPanelDetail = () => {
  const { id } = useParams();
  const [PaymentTest, setPaymentTest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPaymentTestDetails = async () => {
      try {
        setLoading(true);
        setError(null);

        const responseData = await getDataBS('/payment');

        // Find the specific Payment test by ID
        const PaymentTestData = responseData.data['data'].find(
          test => test.id === id
        );

        if (PaymentTestData) {
          // Process and normalize the data structure
          const processedTestData = responseData.data['data']
          .filter(entry => entry.id === id)  // If you still want to match by ID
          .map((entry) => {
            const processedEntry = {};
            for (const key in entry) {
              processedEntry[key] = entry[key] || 'N/A';
            }
            return processedEntry;
          });
        
        setPaymentTest(processedTestData[0]);
        } else {
          setError('Payment test submission not found');
        }
      } catch (error) {
        setError(error.message || 'Failed to fetch Payment test details');
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentTestDetails();
  }, [id]);

  const handleBack = () => {
    navigate('/admin/responses/payment');
  };

  if (loading) {
    return <div className="loading-container">Loading  Payment  details...</div>;
  }

  if (!PaymentTest) {
    return (
      <div className="details-container">
        <div className="not-found">
          <h2>Payments Entires Not Found</h2>
          <p>The submission you're looking for doesn't exist or has been deleted.</p>
          <button onClick={handleBack} className="back-btn">Back to List</button>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="details-container">
        <div className="not-found">
          <h2>Error</h2>
          <p>{error}</p>
          <button onClick={handleBack} className="back-btn">Back to List</button>
        </div>
      </div>
    );
  }

  // Format the submission date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? dateString : date.toLocaleString();
  };

  // Helper function to determine severity label based on score
 

  // Helper function to get severity class
 

  return (
    <div className="details-container">
      <div className="details-header">
        <button onClick={handleBack} className="back-btn">← Back to List</button>
        <h1 className="details-title">Payment Test Submission Details</h1>
      </div>

      <div className={`details-card`}>
        <div className="details-section">
          <h2 className="section-title">Submission Information</h2>
          <div className="info-grid">
            <div className="info-item">
              <label>Full Name</label>
              <div className="info-value">{PaymentTest.name}</div>
            </div>
            <div className="info-item">
              <label>Email Address</label>
              <div className="info-value">{PaymentTest.email}</div>
            </div>
            <div className="info-item">
              <label>Submission Date-Time</label>
              <div className="info-value">
                
                
                 Date:{" "}
                  {(() => {
                    const date = new Date(PaymentTest.date);
                    const year = date.getFullYear();
                    const month = (date.getMonth() + 1)
                      .toString()
                      .padStart(2, "0");
                    const day = date.getDate().toString().padStart(2, "0");
                    return `${year}-${month}-${day}`;
                  })()}
                  <br />
                  Time:{" "}
                  {(() => {
                    const date = new Date(PaymentTest.createdAt);
                    let hour = date.getHours();
                    const minutes = date
                      .getMinutes()
                      .toString()
                      .padStart(2, "0");
                    const ampm = hour < 12 ? "AM" : "PM";
                    hour = hour % 12 || 12;
                    return `${hour
                      .toString()
                      .padStart(2, "0")}:${minutes} ${ampm}`;
                  })()}
                  
                  
                  </div>
            </div>
            
            <div className="info-item">
              <label>Amount</label>
              <div className="info-value score-value">
                {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(PaymentTest.amount) || 'N/A'}
               
              </div>
            </div>
          </div>
        </div>

        <div className="details-section">
  <h2 className="section-title">Payment Details</h2>
  <div className="info-item full-width">
    <table className="response-table">
      <thead>
        <tr>
          <th>Field</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        
        
        
        <tr>
          <td>User_Name</td>
          <td>{PaymentTest.name || 'N/A'}</td>
        </tr>
        <tr>
          <td>Phone Number</td>
          <td>{PaymentTest.number || 'N/A'}</td>
        </tr>
        <tr>
          <td>Email</td>
          <td>{PaymentTest.email|| 'N/A'}</td>
        </tr>
        <tr>
          <td>Payment Type</td>
          <td>{PaymentTest.type || 'N/A'}</td>
        </tr>
        <tr>
          <td>Amount</td>
          <td>{new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(PaymentTest.amount) || 'N/A'}</td>

        </tr>
       
        <tr>
          <td>Submission Date</td>
          <td>{PaymentTest.date || 'N/A'}</td>
        </tr>
        <tr>
          <td>Created At
          </td>
          <td> {" "}
                  {(() => {
                    const date = new Date(PaymentTest.date);
                    const year = date.getFullYear();
                    const month = (date.getMonth() + 1)
                      .toString()
                      .padStart(2, "0");
                    const day = date.getDate().toString().padStart(2, "0");
                    return `${year}-${month}-${day}`;
                  })()}
             {" | "}
                  {(() => {
                    const date = new Date(PaymentTest.createdAt);
                    let hour = date.getHours();
                    const minutes = date
                      .getMinutes()
                      .toString()
                      .padStart(2, "0");
                    const ampm = hour < 12 ? "AM" : "PM";
                    hour = hour % 12 || 12;
                    return `${hour
                      .toString()
                      .padStart(2, "0")}:${minutes} ${ampm}`;
                  })() || 'NA'}</td>
        </tr>
        <tr>
          <td>Utr Number</td>
          <td>{PaymentTest.utr || 'N/A'}</td>
        </tr>
        <tr>
          <td>PhonepaytransactionID</td>
          <td>{PaymentTest.upiTransactionId || 'N/A'}</td>
        </tr>
       
       
        
       
        
        
        
        <tr>
          <td>UPI Transaction ID</td>
          <td>{PaymentTest.upiTransactionId || 'N/A'}</td>
        </tr>
       
       
      </tbody>
    </table>
  </div>
</div>

        {PaymentTest.comments && (
          <div className="details-section">
            <h2 className="section-title">Additional Comments</h2>
            <div className="info-item full-width">
              <div className="info-value message-content">
                {PaymentTest.comments}
              </div>
            </div>
          </div>
        )}

        <div className="details-footer">
          <div className="submission-id">Submission ID: {PaymentTest.id}</div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPanelDetail;